var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var MicOffIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "m5.99 4.075.003.004v.002L20.13 18.218l-1.412 1.414-1.811-1.811a7.983 7.983 0 0 1-3.908 1.617v2.322a.24.24 0 0 1-.24.24h-1.522a.24.24 0 0 1-.24-.24v-2.322c-3.733-.466-6.692-3.505-6.983-7.323L4 11.749a.24.24 0 0 1 .23-.249h1.532a.24.24 0 0 1 .236.23l.012.233a6.004 6.004 0 0 0 5.988 5.537c1.293 0 2.495-.41 3.478-1.109l-1.141-1.142A4.002 4.002 0 0 1 7.995 12l-.001-3.092L4.575 5.49 5.99 4.075ZM19.76 11.5a.24.24 0 0 1 .24.24v.01a7.956 7.956 0 0 1-.63 2.88l-1.57-1.572c.096-.36.16-.734.188-1.118l.007-.209a.24.24 0 0 1 .24-.231h1.524ZM11.997 2a4.002 4.002 0 0 1 4.004 4L16 11.261 8.609 3.869A4.002 4.002 0 0 1 12 2Z", fill: "currentColor", "fill-rule": "evenodd", "fill-opacity": ".86" }))); };
export default MicOffIcon;
